import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      disabled={props.disabled || props.readOnly}
      className={cn(
        "border-input dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-1.5 shadow-sm transition-[color,box-shadow] outline-none",
        "text-sm leading-normal font-regular text-foreground placeholder:text-muted-foreground",
        "focus-visible:border-input focus-visible:ring-ring focus-visible:ring-1",
        "aria-invalid:border-destructive/40 aria-invalid:ring-destructive dark:aria-invalid:ring-destructive/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
